import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireNaturalSort } from '../node_modules/.pnpm/javascript-natural-sort@0.7.1/node_modules/javascript-natural-sort/naturalSort.js';

var naturalSortExports = requireNaturalSort();
const naturalSort = /*@__PURE__*/getDefaultExportFromCjs(naturalSortExports);

export { naturalSort as default };
//# sourceMappingURL=naturalSort.js.map
